import { CARD } from './helper';

const ListSkeleton = () => (
  <div className={`${CARD} overflow-hidden`}>
    <div className="border-b border-gray-100 px-4 py-3.5 sm:px-5">
      <div className="skeleton h-3 w-36" />
    </div>

    <div className="divide-y divide-gray-100">
      {[0, 1].map((row) => (
        <div key={row} className="flex items-center gap-3.5 px-4 py-4 sm:px-5">
          <div className="skeleton h-11 w-11 shrink-0 rounded-xl" />
          <div className="w-full min-w-0">
            <div className="skeleton h-3 w-full max-w-48" />
            <div className="skeleton mt-2 h-2.5 w-full max-w-72" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const VisitsSkeleton = () => (
  <>
    <ListSkeleton />
    <ListSkeleton />
  </>
);

const SectionSkeleton = () => (
  <div className={CARD}>
    <div className="flex items-center gap-3 border-b border-gray-100 px-4 py-3">
      <div className="skeleton h-9 w-9 rounded-xl shrink-0" />
      <div className="skeleton h-3 w-full max-w-28" />
    </div>

    <div className="px-4 py-3 space-y-3">
      {[0, 1, 2].map((row) => (
        <div key={row}>
          <div className="skeleton h-2.5 w-16" />
          <div className="skeleton h-3 w-3/4 mt-2" />
        </div>
      ))}
    </div>
  </div>
);

export const ProfileSkeleton = () => (
  <>
    <SectionSkeleton />

    <div className={`${CARD} flex items-center gap-3 px-4 py-3`}>
      <div className="skeleton h-9 w-9 rounded-xl shrink-0" />
      <div className="w-full min-w-0">
        <div className="skeleton h-2.5 w-16" />
        <div className="skeleton h-3 w-full max-w-32 mt-2" />
      </div>
    </div>

    <SectionSkeleton />
  </>
);
